import {keepPreviousData} from "@tanstack/react-query";
import {useCustomQuery} from "~/query/queryClient";
import {queryHttp} from "~/query/queryHttp";
import type {PageResponse} from "~/services/ApiTypes";
import {userSearchUrl} from "~/pages/supplier-360/services/supplier360Urls";
import type {SupplierContactUser} from "~/pages/supplier-360/types/Supplier360Types";

/**
 * Typeahead over real Mithra accounts (§2.23, re-modeled 2026-10-23 per the user) — the candidates
 * the Identity section's contact multi-selects check people from. Only an existing account can be
 * picked; nothing here creates one.
 *
 * Fetched only while a dropdown is open, and one page deep: `/users/` is paginated (2026-10-24, per
 * the user), so it is the `search` term that narrows the pool, never a client-side filter.
 */
export function useUserSearchQuery(search: string, pageSize: number, enabled: boolean) {
    const url = userSearchUrl(search, pageSize);
    return useCustomQuery({
        queryKey: [url] as const,
        queryFn: async () => (await queryHttp.get<PageResponse<SupplierContactUser>>(url)).data.results,
        enabled,
        placeholderData: keepPreviousData,
    });
}
